export * from "./useTracking";

export enum Event {
  // External Profile
  SubmitForReviewExternal = "Submit for review External Profile",
  SendFeedbackExternal = "Send feedback External Profile",
  FinishReviewExternal = "Finish review External Profile",
  RollbackExternalProfile = "Rollback External Profile",

  SentToBoosting = "Sent to Boosting",
  BoostingFinished = "Boosting finished",

  // Prof Journey
  SubmitForReviewProject = "Submit for review Project",
  SubmitForReviewMilestone = "Submit for review Milestone",
  SubmitForReviewProfJourneyPotential = "Submit for review Professional Journey Potential",
  SubmitForReviewEmployment = "Submit for review Employment", // Prof Journey v1 only
  RollbackProfJourneyPotential = "Rollback Professional Journey Potential",
  RollbackProfJourneyDetails = "Rollback Professional Journey Details",
  RollbackProfJourneyDetailsCompany = "Rollback Professional Journey Details Company",
  RollbackProfJourney = "Rollback Professional Journey", // Prof Journey v1 only
  RollbackProfJourneyCompany = "Rollback Professional Journey Company", // Prof Journey v1 only
  FinishReviewEmployment = "Finish review Employment", // Prof Journey v1 only
  SubmitForReviewEntrepreneurship = "Submit for review Entrepreneurship", // Prof Journey v1 only
  SendFeedbackEntrepreneurship = "Send feedback Entrepreneurship", // Prof Journey v1 only
  SendFeedbackEmployment = "Send feedback Employment", // Prof Journey v1 only
  FinishReviewProject = "Finish review Project",
  FinishReviewMilestone = "Finish review Milestone",
  FinishReviewEntrepreneurship = "Finish review Entrepreneurship", // Prof Journey v1 only
  FinishReviewProfJourney = "Finish review Professional Journey",
  FinishReviewProfJourneyPotential = "Finish review Professional Journey Potential",

  // Referees
  SubmitForReviewPotentialReferees = "Submit for review Potential Referees",
  SubmitForReviewRefereesChoice = "Submit for review Referees Choice",
  SubmitForReviewRefereeDetails = "Submit for Referee Details",
  FinishReviewPotentialReferees = "Finish review Potential Referees",
  FinishReviewRefereesChoice = "Finish review Referees Choice",
  FinishReviewRefereesSelfService = "Finish review self referees section",
  RefereeScoringEdit = "Referee scoring edit",
  RollbackRefereesPotential = "Rollback Referees Potential",
  RollbackRefereesChoice = "Rollback Referees Choice",
  RollbackRefereeDetails = "Rollback Referee Details",
  GenerateAiReferenceLetter = "Generate AI reference letter",
  FinalReferenceLetterGenerated = "Final reference letter generated",

  // Step Provide Doc
  SubmitSectionForReviewStepDoc = "Submit section for review Step Doc",
  SendSectionFeedbackStepDoc = "Send section feedback Step Doc",
  FinishSectionReviewStepDoc = "Finish section review Step Doc",
  FinishReviewStepDoc = "Finish review Step Doc",
  RollbackStepDocExternal = "Rollback StepDoc External",

  // Comments
  ResolveComment = "Resolve comment",

  // Other
  ProfileCompleted = "Profile completed",
  PPBDocumentUploaded = "PPB document uploaded",
}
